import React, {Component} from "react"
import store from "./store/index";
import { addToFilteredCountryList } from "./actions/index";
import { removeFromFilteredCountryList } from "./actions/index";
import ReactCountryFlag from "react-country-flag";


const fullWidth={
  marginTop:'2px',
  width:'300px',
  padding:'2px',
  borderStyle: 'solid',
  backgroundColor:"#57713b",
  color:'#4db36e'
}
const style24={
  width: '30%',
  padding:'2px',
  display: 'inline-block',
  color:'white',
  textAlign:'center'
}
const style25 = {
  width: '35%',
  padding:'2px',
  display: 'inline-block',
  color:'white',
  textAlign:'center'
}

class CheckBox extends Component{
  constructor(props) {
    super(props);
    this.state = {
      isChecked: store.getState().filteredCountryList.includes(this.props.country)
    };
    this.storeBinding = this.storeBinding.bind(this)
    store.subscribe(this.storeBinding)
  }

  storeBinding(){
    console.log("Change Filtered Country list");
    this.state = {
      isChecked: store.getState().filteredCountryList.includes(this.props.country)
    };
  }
//store.getState().filteredCountryList.includes(this.props.country)
  handleCheckboxChange = event =>{
    this.setState({isChecked:event.target.checked})
    if(event.target.checked){
      store.dispatch( addToFilteredCountryList(this.props.country))
    }
    else{
      store.dispatch( removeFromFilteredCountryList(this.props.country))
    }
  }

  render(){

    return(
      <label style={fullWidth}>
         <div style={style25}>{this.props.country}</div>
         <div style={style24}><ReactCountryFlag code={this.props.country}
           styleProps={{
                        width: '30px',
                        height: '30px'
                    }} svg/></div>
         <div style={style24}><input
           name="country"
           type="checkbox"
           checked={store.getState().filteredCountryList.includes(this.props.country)}
           onChange={this.handleCheckboxChange}/></div>
       </label>
    )
  }

}

export default CheckBox
